import { MenuBookListItem } from 'features/MenuBook/models/menuBook';
import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import {
  EatingWayDataSource,
  StoreSettingDetailGetAllRequestPayload,
  StoreSettingDetailGetAllResponse,
  UpdateMobileOrderDisplayRequestPayload,
} from './models';

const storeSettingDetailService = {
  getAll(payload: StoreSettingDetailGetAllRequestPayload): Promise<CommonResponse<StoreSettingDetailGetAllResponse>> {
    const dataDate = moment(payload.data_date).format(DATE_HYPHEN_FORMAT);
    let url = `/restaurant-detail/${payload.restaurant_id}?time_frame_id=${payload.time_frame_id}`;
    url += `&eating_way_id=${payload.eating_way_id}`;
    url += `&assigned_status=${payload.assigned_status}`;
    if (payload.assigned_time_frame_id) {
      url += `&assigned_time_frame_id=${payload.assigned_time_frame_id}`;
    }
    if (payload.menu_book_id) {
      url += `&menu_book_id=${payload.menu_book_id}`;
    }
    if (payload.course_id) {
      url += `&course_id=${payload.course_id}`;
    }
    url += `&data_date=${dataDate}`;
    return axiosClient.get(url);
  },
  updateMobileOrderDisplay(payload: UpdateMobileOrderDisplayRequestPayload): Promise<CommonResponse<any>> {
    const url = `/restaurant-detail/${payload.restaurant_id}/update-mobile-order-display`;
    return axiosClient.post(url, {
      pos_code_id: payload.pos_code_id,
      mobile_order_display_flg: payload.mobile_order_display_flg,
    });
  },
  getEatingWay(timeFrameId: number): Promise<CommonResponse<EatingWayDataSource[]>> {
    let url = `/eating-ways?display_type=3`;
    url += `&time_frame_id=${timeFrameId}`;
    return axiosClient.get(url);
  },
  getMenuBookByEatingWaySetting(timeFrameId: number, eatingwayId: number): Promise<CommonResponse<MenuBookListItem[]>> {
    let url = `/menubooks/get-by-eating-way-setting?time_frame_id=${timeFrameId}&eating_way_id=${eatingwayId}`;
    return axiosClient.get(url);
  },
};

export default storeSettingDetailService;
